export const userFromDto = dto => ({
    ...dto,
    applicationTypeIds: dto.applicationTypeIds.map(id => `${id}`),
    order: ({
        SUPER_ADMIN: 10,
        DEVELOPER_ADMIN: 8,
        APPLICATION_ADMIN: 6,
        ORGANIZATION_ADMIN: 4,
        READ_ONLY_ADMIN: 2,
        END_USER: 0,
    })[dto.roleType]
});



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/administrators.dto.js